"use client"

import { Trans, useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation();

  return (
    <footer
      style={{
        background: "#FFFFFF",
        borderTop: "1px solid #E5E7EB",
        padding: "40px 60px",
        marginTop: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: "1400px",
          margin: "0 auto",
          flexDirection: i18n.dir() === "rtl" ? "row-reverse" : "row",
        }}
      >
        <div
          style={{
            fontFamily: '"Red Hat Display", sans-serif',
            fontSize: "14px",
            color: "#6B7280",
            textAlign: i18n.dir() === "rtl" ? "right" : "left",
          }}
        >
          <Trans
            i18nKey="footer.rights"
            values={{ company: "Rubix", year: "2026" }}
            components={{
              strong: <span style={{ fontWeight: 600, color: "#374151" }} />,
            }}
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer
